/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { Image } from 'antd';
import PropTypes from 'prop-types';
import classes from './DocumentItem.module.scss';

export function DocumentItem(props) {
  const { url, fileName, mimeType = '', height, width = 60 } = props;

  const Document = React.useMemo(() => {
    if (!mimeType) return null;
    switch (mimeType) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/webp':
        return (
          <Image src={url} alt={fileName} width={width} height={height || '100%'} preview={false} />
        );
      case 'video/mp4':
      case 'video/webm':
        return <video src={url} height={height} controls />;
      case 'application/pdf':
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return <div className="file-icon file-icon-md" data-type={mimeType} />;
      default:
        return <div>Unsupported MIME type</div>;
    }
  }, [mimeType]);
  return (
    <a className={classes.item} style={{}} href={url || '#'} target="_blank" rel="noreferrer">
      {Document}
    </a>
  );
}

DocumentItem.defaultProps = {
  mimeType: '',
  width: 45,
  height: 45,
};

DocumentItem.propTypes = {
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  mimeType: PropTypes.string,
};
